module.exports = __webpack_public_path__ + "static/media/wedding.e6aaf5bf.jpg";